import { useEffect, useState } from "react";

/** Lower threshold on narrow viewports so cards animate when scrolled into view. */
export function useIntersectionThreshold(): number {
    const [threshold, setThreshold] = useState(0.28);

    useEffect(() => {
        const mq = window.matchMedia("(max-width: 1023px)");
        const apply = () => setThreshold(mq.matches ? 0.12 : 0.28);
        apply();
        mq.addEventListener("change", apply);
        return () => mq.removeEventListener("change", apply);
    }, []);

    return threshold;
}
